/*
 * TSC copy-a-code buttons.
 *
 * Any element carrying data-tsc-copy="CODE" copies CODE when clicked, then wears
 * the class tsc-copy--done for a moment so its "Copied" label shows. If the
 * browser refuses to copy, it wears tsc-copy--failed instead and the code is
 * left selected so it can be copied by hand.
 *
 * One listener on the document does all of it, so a button the theme editor or a
 * section re-render swaps in later works without being wired up again.
 * The markup and styles are in snippets/tsc-copy-code.liquid.
 */
(function () {
  if (window.__tscCopyCode) return;
  window.__tscCopyCode = true;

  var RESET_AFTER = 1800;
  var timers = new WeakMap();

  // For browsers and in-app browsers where the Clipboard API is missing or refused.
  function legacyCopy(text) {
    var focused = document.activeElement;
    var field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.setAttribute('aria-hidden', 'true');
    field.style.cssText =
      'position:fixed;top:0;left:0;width:1px;height:1px;padding:0;border:0;opacity:0;font-size:16px';
    document.body.appendChild(field);
    field.focus({ preventScroll: true });
    field.select();
    field.setSelectionRange(0, text.length);

    var copied = false;
    try {
      copied = document.execCommand('copy');
    } catch (error) {
      copied = false;
    }

    document.body.removeChild(field);
    if (focused && focused.focus) focused.focus({ preventScroll: true });
    return copied;
  }

  function copy(text) {
    if (navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext) {
      return navigator.clipboard.writeText(text).then(
        function () {
          return true;
        },
        function () {
          return legacyCopy(text);
        }
      );
    }

    return Promise.resolve(legacyCopy(text));
  }

  // Last resort: highlight the code so it can be copied by hand.
  function selectCode(button) {
    var code = button.querySelector('.tsc-copy__code');
    if (!code || !window.getSelection) return;

    var range = document.createRange();
    range.selectNodeContents(code);
    var selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
  }

  function report(button, code, copied) {
    var next = button.nextElementSibling;
    var status = next && next.hasAttribute('data-tsc-copy-status') ? next : null;

    button.classList.toggle('tsc-copy--done', copied);
    button.classList.toggle('tsc-copy--failed', !copied);

    if (status) {
      status.textContent = copied
        ? button.getAttribute('data-tsc-copied') || 'Copied'
        : 'Could not copy. The code is ' + code + '.';
    }

    if (!copied) selectCode(button);

    clearTimeout(timers.get(button));
    timers.set(
      button,
      setTimeout(function () {
        button.classList.remove('tsc-copy--done');
        button.classList.remove('tsc-copy--failed');
        if (status) status.textContent = '';
      }, RESET_AFTER)
    );
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var button = target && target.closest ? target.closest('[data-tsc-copy]') : null;
    if (!button) return;

    var code = button.getAttribute('data-tsc-copy');
    if (!code) return;

    event.preventDefault();
    copy(code).then(function (copied) {
      report(button, code, copied);
    });
  });
})();
